import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ResearchState, Summary, RelevantSource } from './types';
import { Company } from '../company/types';
import { getCompanySummaries } from '../../api/researchApi';
import { orderedSummaryTypes } from '../../pages/research/config';

export const fetchSummaries = createAsyncThunk(
  'research/fetchSummaries',
  async (company: Company, { rejectWithValue }) => {
    try {
      const { summaries, relevantSources } = await getCompanySummaries(
        company.id,
        orderedSummaryTypes,
      );
      return { companyId: company.id, summaries, relevantSources };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

const initialState: ResearchState = {
  summariesByCompany: {},
};

const researchSlice = createSlice({
  name: 'research',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummaries.pending, (state, action) => {
        const companyId = action.meta.arg.id;
        state.summariesByCompany[companyId] = {
          summaries: {},
          relevantSources: [],
          isLoading: true,
          error: null,
        };
      })
      .addCase(
        fetchSummaries.fulfilled,
        (
          state,
          action: PayloadAction<{
            companyId: string;
            summaries: Record<string, Summary>;
            relevantSources: RelevantSource[];
          }>,
        ) => {
          const { companyId, summaries, relevantSources } = action.payload;
          state.summariesByCompany[companyId] = {
            summaries,
            relevantSources,
            isLoading: false,
            error: null,
          };
        },
      )
      .addCase(fetchSummaries.rejected, (state, action) => {
        const companyId = action.meta.arg.id;
        state.summariesByCompany[companyId] = {
          ...state.summariesByCompany[companyId],
          isLoading: false,
          error: action.payload as string,
        };
      });
  },
});

export default researchSlice.reducer;
